(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LT-split-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('split-slider')) {
    class SplitSlider extends HTMLElement {
      constructor() {
        super()
        this.videos = this.querySelectorAll("video")
        this.contentSlider = this.querySelector('.split-slider__content_slider')
        this.contentSliderSettings = {
          centeredSlides: true,
          effect: "fade",
          pagination: {
            el: this.querySelector(".split-slider__content_pagination"),
          }
        }
        this.contentSwiper = null

        this.mediaSlider = this.querySelector('.split-slider__media_slider')
        this.mediaSliderSettings = {
          autoplay: {
            delay: (this.dataset.delay) * 1000,
            disableOnInteraction: false
          },
          centeredSlides: true,
          effect: "fade",
          navigation: {
            nextEl: this.querySelector(".split-slider__media_next"),
            prevEl: this.querySelector(".split-slider__media_prev")
          },
          on: {
            autoplayTimeLeft: (s, time, progress) => this.querySelector('.split-slider__controls').style.setProperty("--progress", 1 - progress),
            slideChangeTransitionStart: (s) => {
              const playing = s.el.querySelector('.playing')
              this.contentSwiper.slideTo(s.el.querySelector('.swiper-slide-active').dataset.index)

              if(s.el.querySelector('.swiper-slide-active video')) s.el.querySelector('.swiper-slide-active video').play()

              if(playing) {
                playing.pause()
                playing.currentTime = 0
              }
            },
          },
          pagination: {
            el: this.querySelector(".split-slider__media_pagination"),
            type: "fraction",
          },
        }
        this.mediaSwiper = null

        document.addEventListener('readystatechange', () => {
          if(document.readyState == 'complete') {
            this.init()
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        })
      }
      init() {
        Array.from(this.videos).forEach(video => {
          video.onplay = (event) => video.classList.add('playing')
          video.onpause = (event) => video.classList.remove('playing')
        });

        if (typeof Swiper !== 'function') {
          this.appendAssets()
          document.addEventListener('readystatechange', () => {
            if (document.readyState == 'complete') {
              this.initSlider()
            }
          })
        } else {
          this.initSlider()
        }
      }
      initSlider() {
        if (this.contentSwiper && this.contentSwiper.destroy) {
          this.contentSwiper.destroy()
          this.contentSwiper = null
        }
        this.contentSwiper = new Swiper(this.contentSlider, this.contentSliderSettings)

        if (this.mediaSwiper && this.mediaSwiper.destroy) {
          this.mediaSwiper.destroy()
          this.mediaSwiper = null
        }
        this.mediaSwiper = new Swiper(this.mediaSlider, this.mediaSliderSettings)
      }
      appendAssets() {
        const link = document.createElement('link')
        const script = document.createElement('script')

        link.rel = 'stylesheet'
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'

        this.appendChild(link)
        this.appendChild(script)

        script.onload = () => this.init()
      }
    }
    customElements.define('split-slider', SplitSlider)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["LT-sticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
